module.exports = __webpack_public_path__ + "static/img/btwzd@3x.7da5c15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/im/btwzd@3x.png
// module id = WdON
// module chunks = 1